// Scan-check results: errorCheck.modelPrediction as returned by
// /new-sample/verify-sample (assembled by the model function's /error-check).
export const SCAN_CHECK = {
  ANALYTE: "Analyte",
  ADVISORY: "Advisory",
  WARNING: "Warning",
  ERROR: "Error",
  NOT_AVAILABLE: "N/A",
};

export const SIGNAL_QUALITY_FALLBACK = "Scan quality could not be determined.";

// Advisory card icon and colour. Placeholders until product picks the final
// ones; they must stay distinct from Warning (orange) and Error (red).
export const ADVISORY_CARD_STYLE = {
  iconClass: "bi-info-circle-fill",
  color: "#0d6efd",
};

const KNOWN_RESULTS = [
  SCAN_CHECK.ANALYTE,
  SCAN_CHECK.ADVISORY,
  SCAN_CHECK.WARNING,
  SCAN_CHECK.ERROR,
];

/**
 * Which scan-check card a scan gets. A missing result is "N/A"; any value
 * this client doesn't recognise is shown, and handled, as a Warning.
 */
export function getScanCheckResult(errorCheck) {
  const prediction = errorCheck?.modelPrediction;
  if (!prediction) return SCAN_CHECK.NOT_AVAILABLE;
  return KNOWN_RESULTS.includes(prediction) ? prediction : SCAN_CHECK.WARNING;
}

/**
 * Whether continuing with this scan submits the sample for reachback.
 * Analyte and Advisory scans continue plainly; everything else (Warning,
 * Error, unknown or missing results) is sent for reachback.
 */
export function scanCheckNeedsReachback(errorCheck) {
  const result = getScanCheckResult(errorCheck);
  return result !== SCAN_CHECK.ANALYTE && result !== SCAN_CHECK.ADVISORY;
}

/** The scan-check message to show, as received, or a fallback if blank. */
export function getSignalQualityText(errorCheck) {
  const text = errorCheck?.signalQuality;
  return typeof text === "string" && text.trim() !== ""
    ? text
    : SIGNAL_QUALITY_FALLBACK;
}
